import {
  DOCUMENT_SESSION_REQUEST,
  DOCUMENT_SESSION_SUCCESS,
  DOCUMENT_SESSION_FAILURE
} from '../actions/documentActions.js'
import merge from 'lodash/merge'

export default function documentSessions(state = {}, action) {
  switch (action.type) {
    case DOCUMENT_SESSION_REQUEST:
      return merge({}, state, {
        [action.document.id]: {
          isFetching: true,
          sessionId: null
        }
      })
    case DOCUMENT_SESSION_SUCCESS:
      return merge({}, state, {
        [action.document.id]: {
          isFetching: false,
          sessionId: action.response.sessionId
        }
      })
    case DOCUMENT_SESSION_FAILURE:
      return merge({}, state, {
        [action.document.id]: {
          isFetching: false,
          sessionId: null
        }
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ../src/reducers/documentSessions.js